import { IDeploymentAndValueStatsGroupedCount } from '@kcftech/prometheustypescriptapiclient';
import { BarChartLegend } from 'pages/Dashboard/components/BarChartLegend';
import { ScrollableBarChart } from 'pages/Dashboard/components/ScrollableBarChart';
import { useMemo } from 'react';
import { Bar, BarChart, CartesianGrid, Tooltip, XAxis, YAxis } from 'recharts';
import { useThemeValues } from 'styles/theme';
import { sortBy } from 'utils/array';

export function AssetCoverage({
    data,
}: {
    data: IDeploymentAndValueStatsGroupedCount[];
}) {
    const theme = useThemeValues();
    const mappedData = useMemo(() => {
        return sortBy(
            data.map((d) => ({ ...d, Name: d.Name || 'Unknown' })),
            (d) => -d.Count
        );
    }, [data]);

    return (
        <ScrollableBarChart
            yAxisWidth={60}
            dataLength={mappedData.length}
            minBarWidthPercent={12}
            legend={
                <BarChartLegend
                    items={[{ label: 'Count', color: theme.dashboardAccentPrimary }]}
                />
            }
        >
            {({ yAxisWidth }) => (
                <BarChart layout="horizontal" data={mappedData} margin={{ left: 10 }}>
                    <defs>
                        <linearGradient
                            id="assetCoverageVertialBarColor"
                            x1="0"
                            y1="0"
                            x2="0"
                            y2="1"
                        >
                            <stop
                                offset="5%"
                                stopColor={theme.dashboardAccentPrimary}
                                stopOpacity={0.75}
                            />
                            <stop
                                offset="95%"
                                stopColor={theme.dashboardAccentPrimary}
                                stopOpacity={0.5}
                            />
                        </linearGradient>
                    </defs>

                    <CartesianGrid
                        strokeDasharray="3 3"
                        horizontal
                        vertical={false}
                        fill=""
                    />

                    <YAxis
                        type="number"
                        width={yAxisWidth}
                        tickFormatter={(v) => v?.toLocaleString()}
                    />

                    <XAxis
                        type="category"
                        dataKey="Name"
                        angle={-45}
                        textAnchor="end"
                        tickFormatter={(value) =>
                            value.length > 10 ? value.substring(0, 10) + '...' : value
                        }
                        height={68}
                    />

                    <Tooltip />

                    <Bar
                        dataKey="Count"
                        fill="url(#assetCoverageVertialBarColor)"
                        radius={[5, 5, 0, 0]}
                    />
                </BarChart>
            )}
        </ScrollableBarChart>
    );
}
